import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["column", "card"]

  dragstart(event) {
    const card = event.currentTarget
    this.draggedLeadId = card.dataset.leadId
    this.draggedCard = card
    this.sourceColumn = card.closest("[data-crm-board-target='column']")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", card.dataset.leadId)
    setTimeout(() => card.classList.add("opacity-50"), 1)
  }

  dragend(event) {
    event.currentTarget.classList.remove("opacity-50")
    this.draggedLeadId = null
    this.draggedCard = null
    this.sourceColumn = null
    this.clearDropIndicators()
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const column = event.currentTarget.closest("[data-crm-board-target='column']")
    if (!column || !this.draggedCard) return

    column.classList.add("ring-2", "ring-primary/40")

    // Position indicator within column
    const cardList = column.querySelector("[data-card-list]")
    const cards = [...cardList.querySelectorAll("[data-crm-board-target='card']")]
      .filter(c => c !== this.draggedCard)

    const afterCard = cards.find(card => {
      const rect = card.getBoundingClientRect()
      return event.clientY < rect.top + rect.height / 2
    })

    if (afterCard) {
      cardList.insertBefore(this.draggedCard, afterCard)
    } else {
      cardList.appendChild(this.draggedCard)
    }
  }

  dragleave(event) {
    const column = event.currentTarget.closest("[data-crm-board-target='column']")
    if (column && !column.contains(event.relatedTarget)) {
      column.classList.remove("ring-2", "ring-primary/40")
    }
  }

  drop(event) {
    event.preventDefault()
    const column = event.currentTarget.closest("[data-crm-board-target='column']")
    if (column) column.classList.remove("ring-2", "ring-primary/40")

    const leadId = event.dataTransfer.getData("text/plain") || this.draggedLeadId
    if (!leadId) return

    const card = this.element.querySelector(`[data-lead-id="${leadId}"]`)
    if (!card) return

    const newStatus = column.dataset.status
    const oldStatus = this.sourceColumn?.dataset.status
    const cardList = column.querySelector("[data-card-list]")
    const position = [...cardList.querySelectorAll("[data-crm-board-target='card']")].indexOf(card)

    this.updateCounts()

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRF-Token": csrfToken,
      "Accept": "text/html"
    }

    if (oldStatus !== newStatus) {
      // Cross-column move: update status then reorder
      fetch(`/leads/${leadId}/move`, {
        method: "PATCH", headers,
        body: `crm_status=${newStatus}`
      }).then(response => {
        if (!response.ok) return window.location.reload()
        // Set position in new column
        fetch(`/leads/${leadId}/reorder`, {
          method: "POST", headers,
          body: `position=${position}`
        })
      })
    } else {
      // Within-column reorder
      fetch(`/leads/${leadId}/reorder`, {
        method: "POST", headers,
        body: `position=${position}`
      }).then(response => {
        if (!response.ok) window.location.reload()
      })
    }
  }

  updateCounts() {
    this.columnTargets.forEach(col => {
      const count = col.querySelectorAll("[data-crm-board-target='card']").length
      const badge = col.querySelector("[data-count]")
      if (badge) badge.textContent = count
    })
  }

  clearDropIndicators() {
    this.columnTargets.forEach(col => {
      col.classList.remove("ring-2", "ring-primary/40")
    })
  }
}
